export default __webpack_public_path__ + "static/media/UploadPhoto.7194451a.svg";